<template>
  <div class="activity">
    <div class="topbanner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in slierImages" :key="index">
          <img :src="item.img" @click="openBanner(item)"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
       </swiper>
      <!-- <img src="@/assets/images/activity_banner.png" alt=""> -->
    </div>
    <div class="newuser" @click="gonewcoupon()">
      <img src="@/assets/images/newuser.png" alt="">
    </div>
    <div class="list" v-for="(item,index) in couponlist" :key="index">
      <div :class="item.PreferentialMode==2?'blue info':'info'">
        <div class="left">
          <!-- <div class="price"><span v-if="item.PreferentialMode!=2">¥</span>{{item.PreferentialMode==2?item.DeductInfo.DiscountRate:item.DeductInfo.CutAmount||70}}<span v-if="item.PreferentialMode==2">折</span></div> -->
          <div class="price" v-if="item.PreferentialMode == 1 || item.PreferentialMode == 3"><span>¥</span>
            {{item.DeductInfo.CutAmount}}
          </div>
          <div class="price" v-if="item.PreferentialMode == 2">
            {{(item.DeductInfo.DiscountRate * 10).toFixed(1)}}<span>折</span>
          </div>
          <div>{{item.PreferentialMode==1?'满减券':item.PreferentialMode==2?'折扣券':'抵现券'}}</div>
        </div>
        <div class="right">
          <div class="top">
            <div class="txt">
              <div class="tit">{{item.OfferName}}</div>
              <div class="time">{{item.ValidBegin.split("T")[0].replace(/\-/g, '\.')+'-'+item.ValidEnd.split("T")[0].replace(/\-/g, '\.')}}</div>
            </div>
            <div class="btn blue" @click="drawcoup(item.CanDrawCoupon,item.OfferID)" v-if="item.CanDrawCoupon">立即领取</div>
            <div class="btn useblue" @click="gorent()" v-else>立即使用</div>
          </div>
          <div class="bottom">
            <div class="txt">详细信息</div>
            <div class="icon" @click="detailInfo(index)"></div>
          </div>
        </div>
      </div>
      <div class="detail" v-if="isShow[index]">
        <div class="txt">{{item.Comments}}</div>
      </div>
    </div>

  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import { getActivityPlatformOffers,DrawCoupon,bannerJSON,getActivityOffers, getAddspaces } from '@/utils/api'
import { resourceUrl,orderSource, imgUrl} from "@/utils/env";

export default {
  name: "activity",
  data() {
    return {
      isShow: [],
      couponlist: [],
      slierImages: [],
      resourceUrl: resourceUrl,
      orderSource: orderSource,
      swiperOption: { // swiper3 组件
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: { delay: 3000 },
          speed: 600,
          loop: true,
      },
      citycode:""
    };
  },
  props: [],
  components:{
    swiper,
    swiperSlide
  },
  created(){
    // this.init();
    this.citycode = this.$route.query.citycode;
    this.getbannerJSON();
  },
  mounted () {
    this.init();
    console.log(this.$route.query.type);
    this.getAddspacesFn(this.$route.query.type)
  },
  methods: {
    async getAddspacesFn(type){
      let res = await getAddspaces({
        data: {
          bizChannel: 16,
          AdSpace: type
        }
      });
      console.log(res)
    },
    init(){
      setTimeout( async ()=>{
        let res = await getActivityPlatformOffers();
        // let res = await getActivityOffers({
        //   data:{
        //     BizChannel:this.orderSource,
        //     CityCode:this.citycode
        //   }
        // });
        if(res.Code==100){
          this.couponlist = res.Data;
          for(let i=0;i<res.Data.length;i++){
            this.isShow.push(false);
          }
        }
      },500);
    },
    async getbannerJSON(){
      let res=await bannerJSON({useApiUrl: false });
      // console.log(res.Data)
      if(res.Code==100){
        let localTime = (Date.parse(new Date()))/1000;
        let _bannerList = res.Data;
        if( _bannerList.length ){
          let _newBanner = [];
          for(let i in _bannerList){
            _bannerList[i].img = imgUrl + _bannerList[i].img;
          }
          for(let i in _bannerList){
            if( localTime > _bannerList[i].startTime && localTime < _bannerList[i].endTime ){
              if( _bannerList[i].channel == 0 || _bannerList[i].channel == this.orderSource ){
                _newBanner.push( _bannerList[i]);
              }
            }
          }
          this.slierImages = _newBanner
        }
      }
    },
    async drawcoup(isdraw,offerid){
      let res = await DrawCoupon({
        data:{ offerId: offerid, orgID: 0 }
      });
      if(res.Code==100){
        this.init(); // 重新加载优惠券列表
        if(this.orderSource==17){
          window.webkit.messageHandlers.updateMemberInfo.postMessage(null);
        }else if( this.orderSource==16 ){
          dfpanda.updateMemberInfo();
        }
      }
    },
    gorent () {
      if(this.orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }else if( this.orderSource==16 ){
        dfpanda.goHome();
      }
    },
    detailInfo(index){
      let show=this.isShow[index];
      this.$set(this.isShow, index, !show)
      // console.log(this.isShow[index]);
    },
    gonewcoupon(){
      this.$router.push({path:"/newcoupon"});
    },
    openBanner(item) {
      // console.log(item);
      switch(item.type){
        case 'html':
          let token = '';
          if( window.localStorage.getItem('token') ){
            token = '?token=' + window.localStorage.getItem('token');
          }
          let _url = resourceUrl + item.path + token;
          if( this.orderSource==17 ){
            window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: 'html', url: _url}));
          }
          if( this.orderSource==16 ){
            dafang.openPage(JSON.stringify({type: 'html', url: _url}))
          }
          break;
      }
    },
  }
};
</script>
<style lang="scss">
.swiper-pagination{
  text-align: center;
}
.topbanner .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  height: 10px;
  width: 10px;
  background-color: #fff;
  opacity: 0.5;
  border-radius: 5px;
}
.topbanner .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>
<style lang="scss" scoped type="text/scss">
.activity {
  width:100%;
  // padding-top:110px;
  background:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  color:#434343;

  .topbanner,.newuser{
    width:680px;
    margin-bottom:32px;
  }
  .topbanner img{
    width:100%;
  }
  .newuser img{
    width:100%;
  }
  .list{
    width:680px;
    background:#fff;
    margin-bottom:25px;
    font-size: 26px;
    .info{
      width:100%;
      height:170px;
      background:url(~@/assets/images/coupon_listbg01.png) no-repeat center;
      background-size: contain;
      display: flex;
      .left{
        width: 210px;
        height:170px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color:#fff;
        text-align: center;
        .price{
          font-size: 70px;
          span{
            font-size: 26px;
          }
        }
      }
      .right{
        font-size: 26px;
        width: 470px;
        height:170px;
        padding:0 23px 0 18px;
        .top{
          height: 125px;
          border-bottom:1px solid #e2e2e2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time{
            font-size: 18px;
          }
          .btn{
            width:125px;
            height: 40px;
            // text-align: center;
            // line-height: 40px;
            border:1px solid #FF8307;/**no**/
            color:#FF8307;
            border-radius: 20px;
            font-size: 22px;
            box-sizing:border-box;
            display: flex;
            justify-content:center;
            align-items:center;
          }
          .btn.blue{
            border:1px solid #FF8307;/**no**/
            color:#fff;
            background:#FF8307;
          }
        }
        .bottom{
          height:45px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color:#999999;
          font-size: 18px;
          .icon{
            width: 0;
            height:0;
            border-left: 8px solid transparent;
            border-right:8px solid transparent;
            border-top: 10px solid #000;
          }

        }
      }
    }
    .info.blue{
      background:url("~@/assets/images/coupon_listbg02.png") no-repeat center;
      background-size: contain;
      .blue {
        border:1px solid #1D8EFF !important;/**no**/
        background: #1D8EFF !important;
      }
      .useblue {
        border:1px solid #1D8EFF !important;/**no**/
        color: #1D8EFF !important;
      }
    }
    .detail{
      border:1px solid #e2e2e2;/**no**/
      border-top:none;
      padding:20px 30px;
      font-size: 18px;
      color:#999999;
    }
  }

}
</style>
